export enum AlertType {
    Warning,
    Information,
    Error,
    Success,
}
